export default __webpack_public_path__ + "static/1-debcc20af929534d25150c2b7442a41f.jpg";